<template>
    <div class="banner-component" :class="mode == 'dark' ? 'dark' : 'light'">
        <div class="uk-section uk-section-xlarge uk-flex uk-flex-column uk-flex-middle">
            <h1 class="uk-text-center uk-visible@s">Your hard work is about to become easier with <span>Harvest</span></h1>
            <h1 class="uk-text-center uk-hidden@s"><span id="mobile-title">Harvest</span></h1>
            <h2 class="uk-text-center">It ain't much, but it's honest work!</h2>
            <button class="uk-button uk-visible@s">
                <a 
                href="https://app.uniswap.org/#/swap?inputCurrency=0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48&outputCurrency=0xa0246c9032bC3A600820415aE600c6388619A14D"
                target="_blank"
                >
                <fa-icon icon="tractor"></fa-icon>
                Buy FARM and plow the fields
                </a>
            </button>
            <button class="uk-button uk-hidden@s">
                <a 
                href="https://app.uniswap.org/#/swap?inputCurrency=0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48&outputCurrency=0xa0246c9032bC3A600820415aE600c6388619A14D"
                target="_blank"
                >
                <fa-icon icon="tractor"></fa-icon>
                Buy FARM
                </a>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "Banner",
    props: {
        mode: String
    }
}
</script>

<style lang="less" scoped>
    @import "../../dark-components/banner.less";

    .uk-section {
        padding-left: .3em;
        padding-right: .3em;

        background-image: url("../../assets/banner-back.png");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;

        h1 {
            font-family: 'Lato';
            font-weight: 900;
            .fluid-font(2, 86, 320, 3840);
            color: @text-color;

            span {
                text-shadow: 
                    -1px -1px 0px lighten(@brand-color, 5%),
                    2px 2px 0px lighten(@brand-color, 5%),
                    3px 3px 0px darken(@brand-color, 2%);
            }

            span#mobile-title {
                .fluid-font(2, 50, 320, 3840);
            }
        }

        h2 {
            margin-top: 0;
            color: @text-color;
            font-family: 'Lato';
            font-weight: 900;
            .fluid-font(1.8, 64, 320, 3840);
        }

        button {
            padding-top: .3em;
            padding-bottom: .3em;
            border-radius: .2em;
            color: @champagne-pink;
            background-color: @brand-shade-color;
            font-family: 'Lato';
            font-weight: 700;
            .fluid-font(1.5, 32, 320, 3840);
            transition: background-color .3s ease-in-out;

            text-transform: none;

            a {
                color: inherit;
                text-decoration: none;
                transition: color .3s ease-in-out;
            }
        }

        button:hover {
            color: lighten(@champagne-pink, 15%);
            background-color: @brand-color;
            transition: all .3s ease-in-out;
        }
    }

    @media only screen and (max-width: 640px) {
        .uk-section {
            background-image: url("../../assets/banner-back-small.png");
        }
    }

</style>